// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"94968250","110":"9cd82b55","193":"a5d55705","225":"59486d33","366":"9d4e300e","424":"0af444c6","464":"06a0b1d4","643":"bc12b670","644":"fbea3e48","771":"892a56ed","957":"4ad06015","962":"32ddd7c3","966":"97a62e40","972":"304691fc","981":"db141019"}[chunkId] + ".chunk.js";
};